const JOINED_STATUSES = new Set([
  'student',
  'active',
  'completed',
  'paused',
  'deferred',
  'dropped',
  'expelled',
  'joined'
]);

export const normalizeAdmissionStatus = (value) => String(value || '').trim().toLowerCase();

const toTimeValue = (value) => {
  if (!value) return 0;
  const dateObj = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(dateObj.getTime()) ? 0 : dateObj.getTime();
};

export const getAdmissionTimelineValue = (student = {}) => (
  toTimeValue(student.admissionFeePaidAt)
  || toTimeValue(student.appDate)
  || toTimeValue(student.createdAt)
  || toTimeValue(student.admissionDate)
  || toTimeValue(student.classStartDate)
);

export const getStudentDisplayName = (student = {}) => (
  student.bio
  || student.displayName
  || student.name
  || 'Unnamed student'
);

export const isPaidAdmissionFeeButNotJoined = (student = {}) => {
  const admissionFeeStatus = normalizeAdmissionStatus(student.admissionFeeStatus);
  if (admissionFeeStatus !== 'paid') {
    return false;
  }

  const studentStatus = normalizeAdmissionStatus(student.userStatus || student.Status || student.status || '');
  return !JOINED_STATUSES.has(studentStatus);
};

